export enum StepNames {
  'nameEmail' = 'nameEmail',
  'profilePic' = 'profilePic',
  'selfieVerification' = 'selfieVerification',
  'services' = 'services',
  'serivceTypes' = 'serivceTypes',
  'homeStudioLocation' = 'homeStudioLocation',
  'mobileLocation' = 'mobileLocation',
  'makeup' = 'makeup',
  'instagram' = 'instagram',
  'hearUs' = 'hearUs',
  'agreement' = 'agreement',
  'finish' = 'finish',
};